import { numberToHumanChart } from '../../../utils/formatter';

export const makeMetricOptions = permissions => [{
  value: 'downloads',
  label: 'Downloads',
  buttonLabel: 'Total Downloads',
}, {
  value: 'dau',
  label: 'DAU',
  buttonLabel: 'Total DAU',
}, {
  value: 'mau',
  label: 'MAU',
  buttonLabel: 'Total MAU',
}, {
  value: 'total_revenue',
  label: 'Total Revenue',
  buttonLabel: 'Total Revenue',
}, {
  value: 'iap_revenue',
  label: 'IAP Revenue',
  buttonLabel: 'IAP Revenue',
}, {
  value: 'download_revenue',
  label: 'Download Revenue',
  buttonLabel: 'Download Revenue',
}, {
  value: 'arpu',
  label: 'ARPU',
  buttonLabel: 'ARPU',
}, {
  value: 'eng',
  label: 'Engagement',
  buttonLabel: 'Engagement',
},
...(permissions.allowSessionsData ? [{
  value: 'sessions',
  label: 'Total Sessions',
  buttonLabel: 'Total Sessions',
}, {
  value: 'tts',
  label: 'Total Time in App',
  buttonLabel: 'Total Time in App',
}] : [])];

export const getMetricName = metric => ({
  downloads: 'Downloads',
  dau: 'DAU',
  mau: 'MAU',
  total_revenue: 'Total Revenue',
  iap_revenue: 'IAP Revenue',
  arpu: 'ARPU',
  eng: 'Engagement',
  sessions: 'Total Sessions',
  tts: 'Total Time in App',
  download_revenue: 'Download Revenue',
})[metric] || '';

export const formatTotalTimeSpent = (tts) => {
  if (!tts) return 0;
  let val = tts / 60;
  let postfix = 'minutes';
  if (val >= 60) {
    val /= 60;
    postfix = 'hours';
  }
  return `${numberToHumanChart(val)} ${postfix}`;
};

export const valueFormatter = (value, metricName) => {
  let newValue;
  if (metricName.indexOf('_revenue') > -1 || metricName === 'arpu') {
    newValue = `$${value < 1 ? value : numberToHumanChart(value)}`;
  } else if (metricName === 'eng') {
    newValue = `${value < 1 ? value : numberToHumanChart(value)}%`;
  } else if (metricName === 'tts') {
    newValue = formatTotalTimeSpent(value);
  } else {
    newValue = `${value < 1 ? value : numberToHumanChart(value)}`;
  }
  return `${newValue}`;
};
